import http from "plugins/axios";

export default {
  //更新后的查询所有用户信息
  getUserList({ page, size, userId, channelId, channelUserId, type, startTime, endTime, billType, coin }) {
    return http.get({
      url: `/ta/admin/channel/bill/spotList?page=${page}&size=${size}&type=${type}&userId=${userId}&channelUserId=${channelUserId}&channelId=${channelId}&startTime=${startTime}&endTime=${endTime}&billType=${billType}&coin=${coin}`,
    });
  },
  exportExcel({ userId, channelId, channelUserId, type, startTime, endTime, billType, coin }) {
    return http.get({
      url: `/ta/admin/channel/bill/spotList/excel?type=${type}&userId=${userId || ''}&channelUserId=${channelUserId || ''}&channelId=${channelId || ''}&startTime=${startTime || ''}&endTime=${endTime || ''}&billType=${billType || ''}&coin=${coin || ''}`,
      responseType: 'blob',
    });
  },
  // 添加备注
  addRemark({ channelId, userId, remark }) {
    return http.post({
      url: `/channel/user/addRemark?channelId=${channelId}&remark=${remark}&userId=${userId}`,
    });
  },
  //钱包资产明细
  getDetail({ userId, coin }) {
    return http.get({
      url: `/channel/spot/detail?userId=${userId}&coin=${coin}`,
    });
  },
  //获取币种列表
  getCoinList(data) {
    return http.get({
      url: '/ta/admin/tenant/coin/list',
      data
    })
  },
  //返佣统计记录
  getDetailRecord({ time, channelId }) {
    return http.get({
      url: `/channel/rebate/info?channelId=${channelId}&time=${time}`,
    });
  },
};
